import React, { useEffect, useState } from "react";
import ChallengesCard from "../Cards/ChallengesCard";
import { CustomBet } from "../CustomBet/CustomBet";
import { GetGameDetails, customBets } from "../../GameServices/GameServices";
const CustomChallenges = ({ id, isAuthenticated, popup,glow }) => {
  const [CustomBets, setCustomBets] = useState([]);
  useEffect(() => {
    FetchGames();
  }, [id]);
  const FetchGames = async () => {
    let { data } = await GetGameDetails(id);
    FetchCustomBets(data?.name);
  };
  const FetchCustomBets = async (name) => {
    let id = localStorage.getItem("user_id");
    let { data } = await customBets(id, name);
    setCustomBets(data);
  };
  return (
    <div className="row justify-content-start mx-auto row w-100">
      {CustomBets?.challenges?.slice(0, 4)?.map((item, index) => {
        return (
          <ChallengesCard
            col={2}
            key={index}
            gameInfo={item}
            isAuthenticated={isAuthenticated}
            handlePopup={(value) => popup(value)}
          />
        );
      })}
      <CustomBet glow = {glow}/>
    </div>
  );
};

export default CustomChallenges;
